import { useTranslation } from "react-i18next";
import FacebookLogin from "react-facebook-login";
import InputText from "../../../components/shared/input-text/component";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppleSignin from "react-apple-signin-auth";
import { getPdfSimpliBaseURL } from "../../../services/api-constants";
import { getFacebookClientId } from "../../../utils/general-config";
import { useNavigate, useParams } from "react-router-dom";
import { getSignInLink } from "../../../utils/path-helper";
import { useEffect, useState } from "react";
import { currentDomain } from "../../../utils/general-config.js";
import { DomainName } from "../../../utils/constants.js";
import { appleClientId, getAppleredirectUri } from "../../../utils/general-config";
import dompurify from "dompurify";

const PSRRightSideSU = ({
  onSignUp,
  disableBtn,
  responseFacebook,
  googleLogin,
  passwordError,
  emailError,
  passwordErrorMsg,
  onEmailChangeHandler,
  emailId,
  onPwdChangeHandler,
  onPasswordKeyPress,
  pwd,
  appleLogin,
  termsOfUse,
  privacyPolicy,
  loginErrorMessage,
  emailErrorMsg,
  loginError,
}) => {
  const { t } = useTranslation();
  const { locale } = useParams();
  const navigate = useNavigate();
  const [hideDocumentLine, setHideDocumentLine] = useState(false);
  let signInLink = getSignInLink(locale, window.location.search);
  const sanitizer = dompurify.sanitize;
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has("ofn")) {
      setHideDocumentLine(true);
    }
  }, []);
  const navigateSignIn = () => {
    navigate(signInLink);
  };

  let Domain = currentDomain().toLowerCase();
  let redirctUri = getAppleredirectUri();
  return (
    <div>
      {" "}
      <section className="relative p-[1px] rounded-[14px] border-2 bg-rs-border-gradient mt-[6px]">
        <div className="rounded-xl py-3 px-2 bg-white shadow-md ">
          <div className="container mx-auto">
            <hgroup className="text-center user-page">
              <h1 className="main-headline  text-ps-reskin-blue text-2xl md:text-4xl font-bold md:font-bold mt-0 lg:mt-[15px] pb-2.5 font-rethink">
                {t("sign_up.ps.headline")}
              </h1>
            </hgroup>
            {/* {hideDocumentLine && (
              <div className="w-full text-center justify-center font-semibold md:text-lg text-md text-ps-reskin-blue">
                {t("sign_up.ps.sub_headline")}
              </div>
            )} */}
            <div
              className="w-full text-center justify-center font-semibold md:text-lg text-md text-ps-reskin-blue"
              dangerouslySetInnerHTML={{
                __html: sanitizer(t("sign_up.ps.sub_headline")),
              }}
            />
            <div
              className={`font-normal text-sm md:text-base text-center align-middle ${
                hideDocumentLine ? "md:my-3" : "md:my-2"
              }  mt-2 mb-4 text-ps-reskin-blue`}
            >
              {Domain === DomainName.PDFSIMPLI ? t("sign_up.ps.content_line1") : t("sign_up.ws.content_line1")}
              <br />
              {Domain === DomainName.PDFSIMPLI ? t("sign_up.ps.content_line2") : t("sign_up.ws.content_line2")}
            </div>
            <div className="social-login  justify-between flex-col">
              <div className="flex items-center">
                <div className="social-login--google w-full mb-0">
                  <button
                    type="button"
                    className="google-login-button text-xs lg:text-sm text-white !bg-[#4181EF] mt-[1px] w-auto !flex items-center justify-center h-[41px] rounded-[5px]"
                    onClick={googleLogin}
                    id="googleBtn"
                  >
                    <div className="bg-white ml-[2px] rounded-l-md">
                      <img
                        src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"}
                        height="20px"
                        width="20px"
                      />
                    </div>
                    <span className="text-sm lg:text-base ml-10 !font-rethink">{t("sign_up.sign_up_with_google")}</span>
                  </button>
                </div>
                <div className="social-login--facebook !leading-none mb-0">
                  <FacebookLogin
                    appId={getFacebookClientId()}
                    autoLoad={false}
                    fields="name,email"
                    textButton=""
                    callback={responseFacebook}
                    cssClass=""
                    size="!w-[41px] !h-[40px] rtl:!hidden"
                    icon={
                      <img
                        src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                        className="facebook-login-button border border-[#EAEBED] !w-[41px] !h-[40px] rtl:!hidden !relative !rounded-[5px]"
                        id="fbBtn"
                      />
                    }
                  />
                </div>
              </div>
              {Domain !== DomainName.SIGNSIMPLI && (
                <div className="social-login--apple w-full">
                  <AppleSignin
                    className="apple-signin-button"
                    authOptions={{
                      clientId: appleClientId(),
                      scope: "email name",
                      redirectURI: redirctUri + "signin-apple",
                      usePopup: true,
                    }}
                    onSuccess={appleLogin}
                    onError={(error) => {
                      console.error("Apple login failed:", error);
                      appleLogin({
                        user: null,
                        authorization: {
                          id_token: null,
                          error: error.message,
                        },
                      });
                    }}
                    uiType="light"
                    buttonExtraChildren={null}
                    style={{ display: "none" }}
                  />
                  <button
                    onClick={() => document.querySelector(".apple-signin-button").click()}
                    className="relative flex items-center justify-center px-2.5 py-2 border border-[#EAEBED] bg-white cursor-pointer rounded-md w-full -mt-[6px]"
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/static/images/apple-icon.svg"}
                      alt="Apple Logo"
                      className="absolute left-3 w-5 h-6"
                    />
                    <span className="text-center ml-5">{t("sign_up.sign_up_with_apple")}</span>
                  </button>
                </div>
              )}
            </div>
            <div className="form-text mb-2 mt-2">
              <>
                {emailError && <p className="text-center bg-red-100">{emailErrorMsg}</p>}
                {passwordError && !emailError && <p className="text-center bg-red-100">{passwordErrorMsg}</p>}
                {loginError && <p className="text-center bg-red-100">{loginErrorMessage}</p>}
              </>
            </div>
            <div className="or-container !font-rethink !text-[#687585] text-sm">
              <span></span> {t("sign_in.or")} <span></span>
            </div>
            <div className="mx-auto my-2 !max-w-96">
              <div className="">
                <InputText
                  showLabel={false}
                  id="email"
                  text="Email Address"
                  onChange={onEmailChangeHandler}
                  className="border-gray-300 rounded  p-2 border mb-3 !font-rethink"
                  value={emailId.trim()}
                  maxLength={100}
                  placeholder={t("sign_in.ps.placeholder_email")}
                />
              </div>
              <div className="">
                <InputText
                  showLabel={false}
                  id="password"
                  text="Password"
                  type="password"
                  onChange={onPwdChangeHandler}
                  value={pwd}
                  className="border-gray-300 rounded  p-2 border mb-3 !font-rethink"
                  onKeyPress={onPasswordKeyPress}
                  placeholder={t("sign_in.ps.placeholder_password")}
                />
              </div>
              <div className="flex flex-col items-center space-y-4">
                <div className="check_box flex justify-between items-center w-full px-1">
                  <span className="font-rethink max-[350px]:!text-[8px] text-xs md:text-sm text-center text-ps-reskin-blue align-middle whitespace-pre-line mx-auto">
                    {t("sign_up.ps.by_continuing")}{" "}
                    <a href={termsOfUse} target="_blank" className="text-[#0E76FF] underline ">
                      {t("sign_up.ps.term_of_use")}
                    </a>
                    <span>
                      {" "}
                      {/* You can adjust the "mx-1" value as needed */}
                      {t("sign_up.ps.and")}
                    </span>
                    <a href={privacyPolicy} target="_blank" className="text-[#0E76FF] underline">
                      {t("sign_up.ps.privacy_policy")}
                    </a>
                  </span>
                </div>
                <div className="fbn bounce-effect md:relative bottom-0 left-0 bg-white border-gray-300 p-0 md:pt-[5px]  md:px-[40px] text-center w-full  z-50">
                  <button
                    id="sign-up"
                    className="text-white p-4 w-full leading-[120%] font-rethink tracking-[2%]  text-md md:text-xl font-bold rounded-[100px] bg-ps-reskin-radial hover:bg-hover-ps-reskin-radial uppercase
 transition-colors duration-1000 ease-in-out"
                    isloading={"false"}
                    disabled={false}
                    type="submit"
                    onClick={onSignUp}
                  >
                    {t("sign_up.ps.btn_cta")}
                  </button>
                </div>

                <p className="mt-3 text-center text-ps-reskin-blue text-sm font-normal pb-0 md:pb-5">
                  {t("sign_up.already_account")}{" "}
                  <button
                    id="sign-up-btn"
                    className="setCulture font-bold  text-[#0E76FF]  !text-sm !font-normal  hover:text-[#f9593a]"
                    isloading={"false"}
                    disabled={disableBtn}
                    onClick={navigateSignIn}
                  >
                    <i>
                      <FontAwesomeIcon icon={faUserCircle} className="text-center text-[#0E77FF] " />
                    </i>{" "}
                    <span className="text-[#0E76FF] underline capitalize">{t("sign_in.ps.headline")}</span>
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default PSRRightSideSU;
